import request from '../utils/request'
const serviceName = 'proOrg'

export function getProOrgTree(data) {
  return request({
    url:`/${serviceName}/getProOrgTree`,
    method:'post',
    data
  })
}

export function getProOrgList(data) {
  return request({
    url:`/${serviceName}/getProOrgList`,
    method:'post',
    data
  })
}

export function addOrUpdateProOrg(newFormFlag, data) {
  var url
  if (newFormFlag) {
    url = 'addProOrg'
  } else {
    url = 'updateProOrg'
  }
  return request({
    url:`/${serviceName}/${url}`,
    method:'post',
    data
  })
}

export function deleteProOrg(data) {
  return request({
    url:`/${serviceName}/deleteProOrg`,
    method:'post',
    data
  })
}

export function getUserByProOrgId(data) {
  return request({
    url:`/${serviceName}/getUserByProOrgId`,
    method:'post',
    data
  })
}

export function assignOrg2Org(data) {
  return request({
    url:`/${serviceName}/assignOrg2Org`,
    method:'post',
    data
  })
}
export function removeUser2Role(data) {
  return request({
    url:`/${serviceName}/removeUser2Role`,
    method:'post',
    data
  })
}

export function checkPartCountByCode(data) {
  return request({
    url:`/${serviceName}/checkPartCountByCode`,
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/proOrg.js